import React from "react";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import RevenueReport from "./reports/revenueReports/RevenueReport";
import CollectionsReport from "./reports/revenueReports/CollectionsReport";
// import ClientsReport from "./ReportComponents/ClientsReport";
// import ActiveClientsReport from "./ReportComponents/ActiveClientsReport";
// import ClientsDropoffReport from "./ReportComponents/ClientsDropoffReport";
// import BlockTherapyReport from "./ReportComponents/BlockTherapyReport";
import ReportButton from "../../applicationUi/components/ReportButton";
import InvoiceReport from "./reports/invoiceReports/invoiceReport";
import ClientStatementReport from "./reports/clientReports/clientStatementReport";
import ClinicianHoursReport from "./reports/clinicianReports/ClinicianHoursReport";
import ClinicianScheduleReport from "./reports/clinicianReports/ClinicianScheduleReport";
import ClinicianAvailabilityReport from "./reports/clinicianReports/ClinicianAvailabilityReport";
import ClinicianClientsReport from "./reports/clinicianReports/ClinicianClientsReport";
import ClientsDropoffReport from "./reports/clientReports/ClientDropoffReport";
import ActiveClientsReport from "./reports/clientReports/ActiveClientsReport";
import ClientHistoryReport from "./reports/clientReports/ClientHistoryReport";
import RecallClientReport from "./reports/clientReports/RecallClientReport";
import QuickBooksInvoicesReport from "./reports/quickbooksReports/QuickBooksInvoicesReport";
import QuickBooksPaymentsReport from "./reports/quickbooksReports/QuickBooksPaymentsReport";
import QuickBooksAuditReport from "./reports/quickbooksReports/QuickBooksAuditReport";
import ClinicPerformanceReport from "./reports/clinicReports/ClinicPerformanceReport";
import BlockTherapyReport from "./reports/clientReports/BlockTherapyReport";
import ClientJourneyProgressReport from "./reports/journeyReports/ClientJourneyProgressReport";
import PDFPaginationTest from "./reports/PDFPaginationTest";
import OrphanedUploadsReport from "./reports/OrphanedUploadsReport";

const reportComponents = {
  "Revenue Report": RevenueReport,
  "Collections Report": CollectionsReport,
  "Invoice Report": InvoiceReport,
  "Client Statement": ClientStatementReport,
  "Clinician Hours Report": ClinicianHoursReport,
  "Clinician Schedule Report": ClinicianScheduleReport,
  "Clinician Availability Report": ClinicianAvailabilityReport,
  "Clinician Clients Report": ClinicianClientsReport,
  "QuickBooks Invoices Report": QuickBooksInvoicesReport,
  "QuickBooks Payments Report": QuickBooksPaymentsReport,
  "QuickBooks Audit Report": QuickBooksAuditReport,
  "Clinic Performance Report": ClinicPerformanceReport,
  "Clients Dropoff Report": ClientsDropoffReport,
  "Active Clients Report": ActiveClientsReport,
  "Client History Report": ClientHistoryReport,
  "Recall Clients Report": RecallClientReport,
  "Block Therapy Report": BlockTherapyReport,
  "Client Journey Progress Report": ClientJourneyProgressReport,
  "PDF Pagination Test": PDFPaginationTest,
  "Orphaned Uploads Report": OrphanedUploadsReport,
  //   "Clients Report": ClientsReport,
  //   "Active Clients Report": ActiveClientsReport,
  //   "Clients Dropoff Report": ClientsDropoffReport,
};

function ReportDetail({ reportName, onBack }) {
  const ReportComponent =
    reportComponents[reportName] || (() => <p>No report available</p>);

  return (
    <div className="p-4">
      <ReportButton
        reportName="Back"
        icon={<ArrowLeftIcon className="h-5 w-5" />}
        onClick={onBack}
        ariaLabel="Back to Reports"
      />
      <h1 className="text-2xl font-bold mt-4">{reportName}</h1>
      <ReportComponent />
    </div>
  );
}

export default ReportDetail;
